import ReactDOM from 'react-dom/client';

import { App } from './app';
import { Provider } from './provider';

/* Render application after Office initializes */
Office.onReady(() => {
  const container = document.getElementById('root')!;
  const root = ReactDOM.createRoot(container);
  root.render(
    <Provider>
      <App />
    </Provider>,
  );
});
